module.exports = __webpack_public_path__ + "img/cms-for-tablets.512ec43d.png";